import {
	Box,
	CardContent,
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useEffect } from "react";
import { Create, Get } from "../../../../../../actions";
import ButtonWithLoading from "../../../../../../components/ButtonWithLoading";
import Card from "../../../../../../components/Card";
import {
	Get_AgendaTemplateList_URL,
	Get_AllAgendaTemplateItems_URL,
	Post_Meeting_UpsertRegularMeetingDraft,
} from "../../../../../../constants/apiUrls";
import { getTranslation } from "../../../../../../heplers/translationHelper";
import { AskAgenda } from "../../../../../public";
import { AskingAgendaList } from "../agenda/askingAgendaList";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";

const AskForAgenda = ({ NextStep, BackStep, initialValues }) => {
	const [templates, setTemplates] = useState([]);
	const [templatesLoading, setTemplatesLoading] = useState(false);
	const [nextButtonClicked, setNextButtonClicked] = useState(false);
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();
	const [draftLoading, setDraftLoading] = useState(false);

	useEffect(() => {
		loadTemplates();
	}, []);

	const loadTemplates = () => {
		setTemplatesLoading(true);
		Get(
			{},
			Get_AgendaTemplateList_URL,
			null,
			(resp) => {
				setTemplates(resp.data);
				setTemplatesLoading(false);
			},
			(error) => {}
		);
	};
	const loadTemplateItems = (templateId, callback) => {
		// setTemplatesLoading(true);
		Get(
			{
				agendaTemplateId: templateId,
			},
			Get_AllAgendaTemplateItems_URL,
			null,
			(resp) => {
				callback(resp.data);
			},
			(error) => {}
		);
	};

	// const initialValues = {
	//     meetingReminders: [],
	//     reminders: [],
	//     isReminderRequired: false,
	//     agendas: [],

	// }

	const setActiveState = (activeState) => ({
		type: "SET_ACTIVE_STATE",
		payload: {
			activeState,
		},
	});

	const setMeetingData = (meetingData) => ({
		type: "SET_MEETING_DATA",
		payload: {
			meetingData,
		},
	});

	return (
		<Formik
		enableReinitialize
			initialValues={initialValues}
			onSubmit={(values, actions) => {
				//  NextStep(values);
				if (nextButtonClicked) {
					let payloadObj = {
						activeStep: 5,
						meetingDraftVm: {...values,activeStep:6},

					};
					console.log("guest draft", payloadObj);
					setDraftLoading(true);
					Create(
						payloadObj,
						Post_Meeting_UpsertRegularMeetingDraft,
						null,
						(resp) => {
							setDraftLoading(false);
							NextStep(values);
						},
						(error) => {
							setDraftLoading(false);
							enqueueSnackbar("Something Went Wrong", {
								variant: "error",
							});
						}
					);
				}
				if (!nextButtonClicked) {
					console.log("draft Documents", values);

					let payloadObj = {
						activeStep: 5,
						meetingDraftVm: values,
					};
					console.log("guest draft", payloadObj);
					setDraftLoading(true);
					Create(
						payloadObj,
						Post_Meeting_UpsertRegularMeetingDraft,
						null,
						(resp) => {
							dispatch(setActiveState(null));
							dispatch(setMeetingData(null));
							setDraftLoading(false);
							window.location.reload();
							enqueueSnackbar("Meeting Draft Successfully", {
								variant: "success",
							});
						},
						(error) => {
							setDraftLoading(false);
							enqueueSnackbar("Something Went Wrong", {
								variant: "error",
							});
						}
					);
				}
			}}
		>
			{({
				errors,
				touched,
				values,
				handleSubmit,
				isSubmitting,
				getFieldProps,
				setFieldValue,
				handleChange,
			}) => (
				<Form>
					<Grid container spacing={2} style={{ marginBottom: "10px" }}>
						{/* Step 4 */}
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Card title={getTranslation("Agenda", "Ordre du jour", "Agenda")}>
								<CardContent>
									<FormControl>
										<FormControlLabel
											label={getTranslation(
												"Asking For Agenda",
												"Demander l'ordre du jour",
												"Tagesordnung erfragen"
											)}
											labelPlacement="start"
											control={
												<Checkbox
													id="isAskingAgendaAllowed"
													checked={values.isAskingAgendaAllowed}
													onChange={handleChange}
												/>
											}
										/>
									</FormControl>
									
										<>
											<br />
											<br />
											{values.isAskingAgendaAllowed ? (
											<TextField
												id="askingAgendaInterval"
												label={getTranslation(
													"Interval (days before)",
													"Intervalle (jours avant)",
													"Intervall (Tage vorher)"
												)}
												required
												size="small"
												variant="outlined"
												name="periodicity"
												type="number"
												{...getFieldProps("askingAgendaInterval")}
												error={
													touched.askingAgendaInterval &&
													Boolean(errors.askingAgendaInterval)
												}
												helperText={
													touched.askingAgendaInterval &&
													errors.askingAgendaInterval
												}
												InputLabelProps={{
													shrink: true,
												}}
												style={{ width: "400px" }}
											/>
											):null}
											<br />
											<br />
											<Autocomplete
												style={{ width: "400px" }}
												options={templates}
												getOptionLabel={(option) => option?.name}
												size="small"
												onChange={(e, value) => {
													loadTemplateItems(value?.id, (agendas) => {
														setFieldValue("agendas", agendas);
													});
												}}
												renderInput={(params) => (
													<TextField
														required
														{...params}
														label={getTranslation(
															"Template",
															"Modèle",
															"Vorlage"
														)}
														variant="outlined"
														error={touched.template && Boolean(errors.template)}
														helperText={touched.template && errors.template}
													/>
												)}
											/>
											<br />
											<AskingAgendaList
												agendas={values.agendas}
												onAgendaRemoved={(agenda) => {
													const arr = values.agendas.filter((x) => x != agenda);
													setFieldValue("agendas", arr);
												}}
												onNewAgendaAdded={(agenda) => {
													const arr = values.agendas;
													arr.push(agenda);
													setFieldValue("agendas", arr);
												}}
												onUpdateAgenda={(index, agenda) => {
													const arr = values.agendas;
													arr[index] = agenda;
													setFieldValue("agendas", arr);
												}}
											/>
										</>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
					<Box
						display="flex"
						justifyContent="space-between"
						alignItems="space-between"
						m={2}
					>
						<ButtonWithLoading
							title={getTranslation("Back", "Précédent", "Zurück")}
							color="primary"
							variant="contained"
							size="large"
							onClick={() => BackStep()}
						/>
						<Box display="flex">
							{/* <div style={{ marginRight: "10px" }}>
								<ButtonWithLoading
									title={getTranslation(
										"Save as Draft",
										"Save as Draft",
										"Save as Draft"
									)}
									color="primary"
									variant="contained"
									size="large"
									//onClick={handleSubmit}
									loading={draftLoading}
									onClick={() => {
										setNextButtonClicked(false);
										handleSubmit();
									}}
								/>
							</div> */}

							<ButtonWithLoading
								title={getTranslation("Next", "Suivant", "Weiter")}
								color="primary"
								variant="contained"
								size="large"
								//onClick={handleSubmit}
								loading={draftLoading || nextButtonClicked}
								onClick={() => {
									setNextButtonClicked(true);
									handleSubmit();
								}}
							/>
						</Box>
						{/* <ButtonWithLoading
                            title={getTranslation("Next", "Suivant", "Weiter")}
                            color="primary"
                            variant="contained"
                            size="large"
                            onClick={handleSubmit}
                        /> */}
					</Box>
				</Form>
			)}
		</Formik>
	);
};
export default AskForAgenda;
